import { render, staticRenderFns } from "./ShopperProduct.vue?vue&type=template&id=d16bdac2&"
import script from "./ShopperProduct.vue?vue&type=script&lang=js&"
export * from "./ShopperProduct.vue?vue&type=script&lang=js&"
import style0 from "./ShopperProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports